
        import CitedBy from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/aan-ctm-maint-250409-0d22da74/ui-products/wk/aan/node_modules/ui-theme/widgets/cited-by/index';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/aan-ctm-maint-250409-0d22da74/ui-products/wk/aan/widgets/axel-publication-content/js/axel-publication-content';
  
import ShowRecommended from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/aan-ctm-maint-250409-0d22da74/ui-products/wk/aan/node_modules/ui-theme/widgets/show-recommended/index';  
const main = (UX) => {
    const $citedBy = document.getElementById('cited-by'),
        $showRecommended = Array.prototype.slice.call(document.getElementsByClassName('show-recommended-placeholder'))

try {
        if ($citedBy ) {
            UX.citedBy = new CitedBy($citedBy).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showRecommended.length ) {
            UX.showRecommended = $showRecommended
                .map(item=>new ShowRecommended(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        